import React from 'react';

import {
    DeletedTooltipIcon,
    OwnWorkingCopyTooltipIcon,
    ReadOnlyTooltipIcon,
    WorkingCopyTooltipIcon
} from './tooltip-icons';
import {isDocumentBeingEdited} from '../../../../utils/document';

interface Props {
    document: EditModeDoc;
}

export interface StatusIconSettings {
    showDeleted: boolean;
    showReadOnly: boolean;
}

export function DocumentEditStatusIcon({
    document,
    showDeleted,
    showReadOnly
}: Props & StatusIconSettings) {
    if (showDeleted && document.status === 'DELETED') {
        return <DeletedTooltipIcon />;
    }

    if (showReadOnly && document.readOnly) {
        return <ReadOnlyTooltipIcon />;
    }

    if (document.editedByCurrentUser) {
        return <OwnWorkingCopyTooltipIcon />;
    }

    if (isDocumentBeingEdited(document)) {
        return <WorkingCopyTooltipIcon />;
    }
}
